import { ApprRouteProgressDialog } from '@/common/appr/ApprRouteProgressDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from './TitleButton';

export const ApprRouteProgressButton = ({ apprJobId }) => {
  const { entityObj } = useEntityMgr();
  const { openDialog } = useDialog();

  const openApprRouteProgressDialog = () => {
    const data = { apprJobId: apprJobId ?? entityObj.apprJobId };
    openDialog(ApprRouteProgressDialog, { data });
  };

  return <TitleButton icon={fas.faStamp} toolTip="View Approval Route" onClick={openApprRouteProgressDialog} />;
};
